// ============================================================
// EDIT THIS FILE: replace the placeholder contact details below
// with the real Social Wavez Technologies details.
// ============================================================

export const SITE = {
  name: "Social Wavez Technologies",
  tagline: "We Build the Systems Your Business Runs On.",
  // PLACEHOLDER contact details — replace with real ones:
  email: "info@socialwavez.com", // TODO: replace
  sales_email: "sales@socialwavez.com", // TODO: replace

  hrMail: "hr@socialwavez.com",
  phone: "+91 96256 71955",
  whatsapp: 'https://wa.me/919625671955?text=Hi%20Social%20Wavez%2C%20I%20want%20to%20discuss.', // TODO: replace
  // CALENDLY: paste your Calendly event URL to enable the live inline embed,
  // e.g. "https://calendly.com/socialwavez/discovery-call"
  // Leave empty to show the styled placeholder panel on the Contact page.
  calendlyUrl: "https://calendly.com/srivastavsatyam137/30min",
  socials: {
    linkedin: "https://www.linkedin.com/company/social-wavez/", // TODO: replace
    twitter: "https://twitter.com/socialwavez", // TODO: replace
    youtube: "https://www.youtube.com/channel/UCp9mqQKZCjG9J-JlZZ2KBZg", // TODO: replace
    instagram: "https://www.instagram.com/socialwavez__/", // TODO: replace
    github: "#", // TODO: replace
  },
};
